module.exports = __webpack_public_path__ + "static/media/bubble.dd0cf072.mp3";